module.exports = function getResource(label, vars = []) {
    const resources = {
        titleLabel: 'Look up your order',
        orderNumberInputLabel: 'Order number',
        emailInputLabel: 'Email address',
        submitButtonLabel: 'Find my order',
        signInText1: 'If you have an account,',
        signInText2: 'to view your order history.',
        signInLinkText: 'sign in'
    };
    return resources[label];
};
